<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path d="M833.5 350.5v138.6c0 26.6-19.8 48.1-44.2 48.1h-33.1c-7.1 0-12.9-5.7-12.6-12.9 0-7 5.7-12.8 12.8-12.8h25.7c16.6 0 25.7-6.5 25.7-25.7V350.5c0-3.5 2.8-6.5 6.5-6.5H827c3.5.1 6.5 2.9 6.5 6.5z" data-follow-fill="currentColor" :fill="_fill" />
      <path d="M743.5 524.3c0-7 5.7-12.8 12.8-12.8H782c16.6 0 25.7-6.5 25.7-25.7V350.5c0-3.5 2.8-6.5 6.5-6.5H827c3.5 0 6.5 2.8 6.5 6.5v138.6c0 26.6-19.8 48.1-44.2 48.1h-33.1c-7.2 0-12.9-5.7-12.7-12.9z" data-follow-fill="currentColor" :fill="_fill" />
      <path d="M385.8 637.2V189.5c0-55.2 44.9-100 100-100h447.7v447.7c0 55.2-44.9 100-100 100H385.8zM498.6 148c-30.1 0-54.5 24.5-54.5 54.5v376.4h376.4c30.1 0 54.5-24.5 54.5-54.5V148H498.6z" data-follow-fill="currentColor" :fill="_fill" />
      <path d="M833.5 350.5v138.6c0 26.6-19.8 48.1-44.2 48.1h-33.1c-7.1 0-12.9-5.7-12.6-12.9 0-7 5.7-12.8 12.8-12.8h25.7c16.6 0 25.7-6.5 25.7-25.7V350.5c0-3.5 2.8-6.5 6.5-6.5H827c3.5.1 6.5 2.9 6.5 6.5zm-744 583V485.8c0-55.2 44.9-100 100-100h138.7v58.3H202.5c-30.1 0-54.5 24.5-54.5 54.5V875h376.4c30.1 0 54.5-24.5 54.5-54.5V707.6h58.3v125.8c0 55.2-44.9 100-100 100H89.5zm615.1-396.3c7.1 0 12.8-5.8 12.8-12.8 0-7-5.8-12.8-12.8-12.8-7.1 0-12.8 5.8-12.8 12.8 0 7 5.7 12.8 12.8 12.8z" data-follow-fill="currentColor" :fill="_fill" />
    </g>
  </svg>
</template>

<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
